<ion-app>
  @if (pageLoaderVisible) {
    <div class="global-page-loader">
      <ion-spinner name="crescent"></ion-spinner>
    </div>
  }
  <app-side-menu></app-side-menu>
  <app-update-banner></app-update-banner>
  <app-maintenance-banner></app-maintenance-banner>
  <ion-router-outlet id="main-content"></ion-router-outlet>
  <app-cookie-banner></app-cookie-banner>
  <app-support-widget></app-support-widget>
</ion-app>
